var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedFileIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2762 14.276L20.3908 12.3907C20.1408 12.1407 19.8015 12 19.4482 12H14.6668C13.9302 12 13.3335 12.5967 13.3335 13.3333V22.6667C13.3335 23.4033 13.9302 24 14.6668 24H21.3335C22.0702 24 22.6668 23.4033 22.6668 22.6667V15.2187C22.6668 14.8653 22.5262 14.526 22.2762 14.276V14.276Z",
    stroke: "#0086C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6668 15.3333H20.0002C19.6322 15.3333 19.3335 15.0347 19.3335 14.6667V12",
    stroke: "#0086C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 17.4134H17.5",
    stroke: "#0086C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 19.3333H17.5",
    stroke: "#0086C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 21.2533H17.5",
    stroke: "#0086C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4168 17.3333C15.3708 17.3333 15.3335 17.3706 15.3335 17.4166C15.3335 17.4626 15.3708 17.4999 15.4168 17.4999C15.4628 17.4999 15.5002 17.4626 15.5002 17.4166C15.5002 17.3706 15.4628 17.3333 15.4168 17.3333",
    stroke: "#0086C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4168 19.25C15.3708 19.25 15.3335 19.2873 15.3335 19.3333C15.3335 19.3793 15.3708 19.4167 15.4168 19.4167C15.4628 19.4167 15.5002 19.3793 15.5002 19.3333C15.5002 19.2873 15.4628 19.25 15.4168 19.25",
    stroke: "#0086C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4168 21.1667C15.3708 21.1667 15.3335 21.2041 15.3335 21.2501C15.3335 21.2961 15.3708 21.3334 15.4168 21.3334C15.4628 21.3334 15.5002 21.2961 15.5002 21.2501C15.5002 21.2041 15.4628 21.1667 15.4168 21.1667",
    stroke: "#0086C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#F0F9FF",
    strokeOpacity: 0.7,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedFileIconBlue);
export default __webpack_public_path__ + "static/media/featured-file-icon-blue.f0ce10e15e285f212aff432f0a51f593.svg";
export { ForwardRef as ReactComponent };